module.exports = __webpack_public_path__ + "static/media/bg-modal-confirm5377111ac4fe581be2b30a31e214e8ed.webp";